export const getDealerNameFromUrl = () => {
  const path = window.location.pathname;
  const segments = path.split("/");
  return segments[1].trim();
};

export const getIdsFromPath = (
  path?: string,
): {
  application_id?: string;
  borrower_id?: string;
  dealer_id?: string;
} => {
  const pathname = path || window.location.pathname;
  const matchPattern =
    /\/([^/]+)\/application\/([^/]+)(?:\/borrower\/([^/]+))?/;
  const match = pathname.match(matchPattern) ?? [];

  return {
    dealer_id: match[1] ?? getDealerNameFromUrl(),
    application_id: match[2],
    borrower_id: match[3],
  };
};
